import UserCrewMemberDTO from '@src/adapters/dto/user/UserCrewMemberDTO';
import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  user: UserCrewMemberDTO;
}

interface Result {
  user: UserCrewMemberDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/user_crew_member',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveCrewMemeber = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveCrewMemeberLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveCrewMemeber;
